export default "__VITE_ASSET__CmZPTSAr__"